import { Component, OnInit } from '@angular/core';
import { NoDataActionType } from '../../../../../shared/interfaces/no-data';
import { CustomDashboardsService } from '../../../../services/my-limegear.service';
import { ILeadsSmalCard } from '../../interfaces/stanalone-components.data';
import { SmallMediumCardService } from '../../services/small-medium-card.service';

@Component({
    selector: 'total-leads-smdc',
    templateUrl: './total-leads-smdc.component.html',
    styleUrls: ['./total-leads-smdc.component.scss'],
})
export class TotalLeadsSmdcComponent implements OnInit {
    constructor(
        private _customDashboardsService: CustomDashboardsService,
        private _smallcardService: SmallMediumCardService
    ) {}
    leadsPartnersSmallCard: ILeadsSmalCard;
    ngOnInit() {
        let action = NoDataActionType.pageStart;
        let searchTerm = '';
        this.leadsPartnersSmallCard = {
            cardId: 'totalLeads',
            title: 'Total Leads',
            databaseCardId: 'Total Leads',
            cardGroup: 'summary',
            urlSegment: 'totalLeads',
            action: action,
            searchTerm: searchTerm,
        };

        this._customDashboardsService.filterChangesSubject$.subscribe((changes) => {
            this.leadsPartnersSmallCard = this._smallcardService.initializeSamllCard(
                this.leadsPartnersSmallCard
            );
            this._smallcardService.prepareLeadsAndPartnersSmallcardData(
                this.leadsPartnersSmallCard,
                changes.displayOptions,
                changes.hierarchyfilters,
                changes.action
            );
        });
    }
}
